import { Component, OnInit } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import {
  SearchGlobal,
  ResponseSearchGlobal
} from 'src/app/shared/models/global-search.model';
import { IUser } from 'src/app/shared/models/login.model';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { ICompany } from '@shared/models/company.model';
import { HttpService } from 'src/app/core/http/http.service';
import { GlobalSearchService } from '@shared/services/global-search.service';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/unsuscribe-adapter/unsuscribe-adapter';
import { debounceTime } from 'rxjs/operators';
import { GlobalSearchTranslatorPipe } from '@shared/pipes/globall-search-translator.pipe';
import { environment } from 'src/environments/environment';
import { ALL_COMPANIES } from '@shared/modules/company-filter/company-filter.component';
import { UserService } from '@shared/services/user.service';

@Component({
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss']
})
export class GlobalSearchComponent extends UnsubscribeOnDestroyAdapter
  implements OnInit {
  private subject: Subject<string> = new Subject();
  control = new FormControl();
  filteredResults: Observable<SearchGlobal[]>;
  filteredOnlyResults: ResponseSearchGlobal[] = [];
  environmentUrl = environment.resourcesUrl;
  user: IUser;
  company: ICompany;
  contSelection = -1;
  filterValue: string;
  requesting = false;

  constructor(
    private router: Router,
    private service: HttpService,
    private gS: GlobalSearchService,
    private statusTranslator: GlobalSearchTranslatorPipe,
    private userService: UserService
  ) {
    super();
    this.user = this.userService.userInfo;
    this.company = JSON.parse(localStorage.getItem('COMPANY_INFO'));
  }

  ngOnInit() {
    this.subs.add(
      this.subject.pipe(debounceTime(500)).subscribe(searchTextValue => {
        this._filter(searchTextValue);
      })
    );
  }

  searchValueInModule(module: string): void {
    this.gS.addOrEditSearch({
      name: 'search',
      value: this.filterValue,
      module: module.replace('s', '') as any
    });
    this.gS.addOrEditSearch({
      name: 'status',
      value: this.statusTranslator.transform(
        module === 'orders' ? 'my_orders' : 'awaiting_priceView'
      ),
      module: module.replace('s', '') as any
    });
    this.identifyType(module.replace('s', '') as any);
    this.contSelection = -1;
  }

  private _filter(value: string): void {
    this.filterValue = value;
    this.contSelection = -1;
    this.filteredOnlyResults = [];
    this.requesting = true;
    this.subs.add(
      this.service.get('search/' + this._normalizeValue(value), {}).subscribe(
        (results: SearchGlobal[]) => {
          this.filteredResults = of(results) as any;
          this.filteredOnlyResults = [...results].map(item => {
            return {
              ...item,
              results: item.results.map(result => {
                return {
                  category: item.category,
                  ...result
                };
              })
            };
          }) as any;
          this.requesting = false;
        },
        error => {
          this.filteredResults = of([]) as any;
          this.requesting = false;
        }
      )
    );
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }

  filterResults(event) {
    const value = event.target.value;
    if (
      value.trim() !== '' &&
      event.key !== 'ArrowDown' &&
      event.key !== 'ArrowUp' &&
      event.key !== 'Enter'
    ) {
      if (value.length > 3) {
        this.contSelection = -1;
        this.subject.next(value);
      } else {
        this.filterValue = null;
        this.filteredResults = of([]) as any;
      }
    } else if (
      event.key === 'ArrowDown' &&
      this.contSelection < this.filteredOnlyResults.length - 1
    ) {
      this.contSelection++;
    } else if (event.key === 'ArrowUp' && this.contSelection > 0) {
      this.contSelection--;
    } else if (event.key === 'Enter') {
      this.selectResult(
        this.filteredOnlyResults[this.contSelection],
        this.filteredOnlyResults[this.contSelection].category
      );
    }
  }

  selectResult(resultSelect: ResponseSearchGlobal, category: string) {
    this.gS.addOrEditSearch({
      name: 'search',
      value: resultSelect.fd_number,
      module: category.replace('s', '') as any
    });
    this.gS.addOrEditSearch({
      name: 'status',
      value: this.statusTranslator.transform(
        resultSelect.Status.name.replace(/ /g, '_')
      ),
      module: category.replace('s', '') as any
    });
    if (category.indexOf('lead') == -1) {
      const source = resultSelect.Source;
      localStorage.setItem('COMPANY_STORE', JSON.stringify(ALL_COMPANIES));
      this.gS.addOrEditSearch({
        name: 'company',
        value: ALL_COMPANIES.companies_id,
        module: category.replace('s', '') as any
      });
    }
    this.identifyType(category.replace('s', '') as any);
    this.contSelection = -1;
  }

  identifyType(category: string) {
    switch (category) {
      case 'order':
        this.fireReload('/main/orders');
        break;
      case 'quote':
        this.fireReload('/main/quotes');
        break;
      case 'lead':
        this.fireReload('/main/leads');
        break;
    }
  }

  fireReload?(urlDestine: string): void {
    const route = window.location.href;
    if (route.indexOf(urlDestine) !== -1 && route.indexOf('/detail') === -1) {
      // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    } else {
      this.router.navigate([urlDestine]);
      this.filterValue = null;
      this.filteredResults = of([]) as any;
    }
  }
}
